import { render, staticRenderFns } from "./MainGeneralForm.vue?vue&type=template&id=6d722da2"
import script from "./MainGeneralForm.vue?vue&type=script&lang=js"
export * from "./MainGeneralForm.vue?vue&type=script&lang=js"
import style0 from "./MainGeneralForm.vue?vue&type=style&index=0&id=6d722da2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports